<!--suppress ALL -->
<template lang="pug">
  v-card(v-bind='$attrs', :style='styles', v-on='$listeners')
    .v-card--material
      helper-offset(v-if='hasOffset', :inline='inline', :full-width='fullWidth', :offset='offset')
        v-card.pa-4(v-if="!$slots.offset" :class='`elevation-${elevation}`', :color='color', dark='' ) {{ title }}
        slot(v-else name="offset")
      .text-xs-right
        p.category.grey--text.font-weight-light(:style="'width: 500px'")
          slot(name='header')
    v-card-title(v-if='$slots.tools')
      slot(name='tools')
    v-card-text
      slot
    v-divider.mx-3(v-if='$slots.actions')
    v-card-actions(v-if='$slots.actions')
      slot(name='actions')
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    elevation: {
      type: [Number, String],
      default: 10
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    }
  },

  computed: {
    hasOffset() {
      return this.$slots.header || this.$slots.offset || this.title || this.text
    },
    styles() {
      if (!this.hasOffset) return null

      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset * 2}px`
      }
    }
  }
}
</script>

<style lang="scss">
.v-card--material {
  &__header {
    &.v-card {
      border-radius: 4px;
    }
  }
}

.v-card--material {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .text-xs-right {
    padding: 0px 16px 0;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }

}

.v-card__title {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
